exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".form-container {\n  max-width: 500px;\n  margin: 15px auto;\n  border: 1px solid #dddddd;\n  text-align: left;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);\n  border-radius: 5px;\n  padding: 15px; }\n  @media all and (max-width: 540px) {\n    .form-container {\n      margin: 15px; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/scenes/BasicForm/style.scss
// module id = 586
// module chunks = 0